import { Capacitor } from '@capacitor/core';
import ClientOAuth2 from 'client-oauth2';

if (typeof process.env.REACT_APP_OAUTH_AUTH_URL == "undefined"
  || typeof process.env.REACT_APP_OAUTH_TOKEN_URL == "undefined"
  || typeof process.env.REACT_APP_OAUTH_CLIENT_ID == "undefined") {
    throw Error("API variables not found.");
}

export default new ClientOAuth2({
  clientId: process.env.REACT_APP_OAUTH_CLIENT_ID,
  accessTokenUri: process.env.REACT_APP_OAUTH_TOKEN_URL,
  authorizationUri: process.env.REACT_APP_OAUTH_AUTH_URL,
  redirectUri: (Capacitor.isNative ? 'clusterx://app.clusterx.com' : window.location.origin) + "/auth/rbn/callback",
  scopes: ['openid', 'email', 'profile', 'access_features', 'offline_access'],
})